import "./App.css";

import {
  Navigate,
  RouterProvider,
  createBrowserRouter,
} from "react-router-dom";
import StudentRegistration from "./pages/StudentRegistration/StudentRegistration";
import Registration from "./pages/Registration/Registration";
import Summary from "./pages/Summary";

const router = createBrowserRouter([
  { path: "/", element: <Navigate to={"/studentska-prijava"} replace /> },
  { path: "/prijava", element: <Registration /> },
  { path: "/studentska-prijava", element: <StudentRegistration /> },
  { path: "/uspesno-poslano/:type", element: <Summary /> },
]);

function App() {
  return <RouterProvider router={router} />;
}

export default App;
